<template>
  <v-switch
    :model-value="add_to_calendar"
    color="green"
    @update:model-value="updateAddToCalendar"
    :true-value="1"
    :false-value="0"
    :disabled="!hasWritePermission"
  ></v-switch>
</template>

<script>
import apiClient from "@/core/buildRequest";
import { useEventsStore } from "@/store/crm/useEventsStore";
import { useGeneralStore } from "@/store/General";
import { loginForm } from "@/store/logIn";

export default {
  name: "statusCol",
  props: ["item", "id"],
  data() {
    return {
      loginStore: loginForm(),
      add_to_calendar: 0,
      event_store: useEventsStore(),
      general_store: useGeneralStore(),
    };
  },
  mounted() {
    this.add_to_calendar = Number(this.item.add_to_calendar) ?? 0;
  },
  computed: {
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
  created() {
    this.eventStore = useEventsStore();
  },
  watch: {
    "item.add_to_calendar"(newValue) {
      this.add_to_calendar = Number(newValue) ?? 0;
    },
  },
  methods: {
    handleClickPermission() {
      if (!this.hasWritePermission) return;
    },
    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
    async updateAddToCalendar(value) {
      this.add_to_calendar = value;
      try {
        await apiClient
          .post(`/leads-managment/events/add_to_calender/${this.id}`, {
            add_to_calendar: value,
          })
          .then((res) => {
            this.event_store.updateAddToCalender(this.id, value);
            this.general_store.showSnackbar(res.data.msg,"#237276");
          });
      } catch (error) {
        console.error("Error updating add_to_calendar:", error);
      }
    },
  },
};
</script>
